import React, { useState } from 'react';

import Footer from '../components/Footer';
import Navbar from '../components/Navbar';


import image01 from '../assets/CardsImages/card-7-img/img-91.jpg'
import image02 from '../assets/CardsImages/card-7-img/img-92.jpg'
import image03 from '../assets/CardsImages/card-7-img/img-93.jpg'
import image04 from '../assets/CardsImages/card-7-img/img-94.jpg'
import image05 from '../assets/CardsImages/card-7-img/img-95.jpg'
import image06 from '../assets/CardsImages/card-7-img/img-96.jpg'
import image07 from '../assets/CardsImages/card-7-img/img-97.jpg'
import image08 from '../assets/CardsImages/card-7-img/img-98.jpg'
import image09 from '../assets/CardsImages/card-7-img/img-99.jpg'
import image10 from '../assets/CardsImages/card-7-img/img-100.jpg'
import image11 from '../assets/CardsImages/card-7-img/img-101.jpg'
import image12 from '../assets/CardsImages/card-7-img/img-102.jpg'
import image13 from '../assets/CardsImages/card-7-img/img-103.jpg'
import image14 from '../assets/CardsImages/card-7-img/img-104.jpg'
import image15 from '../assets/CardsImages/card-7-img/img-105.jpg'
import image16 from '../assets/CardsImages/card-7-img/img-91.jpg'

const Card07 = () => {

    
        const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image
    
        const images = [
            image01,
            image02,
            image03,
            image04,
            image05,
            image06,
            image07,
            image08,
            image09,
            image10,
            image11,
            image12,
            image13,
            image14,
            image15,
            image16
    
    
            // Add the rest of the images here...
        ];
    
        const handleImageClick = (image) => {
            setSelectedImage(image); // Set the selected image
        };
    
        const handleClose = () => {
            setSelectedImage(null); // Clear the selected image
        };
    
    
    return (

        <div>
            {/* <Navbar /> */}
            <div className="container mx-auto px-6 py-12 mt-8">
                <h1 className="text-3xl font-bold text-center text-purple-950 mb-8">Technical Advisor</h1>
                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">
                    <h2 className="text-2xl font-semibold mb-4">Technical Advisor Job</h2>
                    <p className="mb-4">
                    A technical advisor is an expert or consultant with specialized knowledge and experience in a particular technical field or industry. Their role is to provide guidance, advice, and support to individuals, organizations, or projects that require technical expertise. Here are some key responsibilities and characteristics of a technical advisor:
                    </p>
                </div>

                <div className="container mx-auto px-4 py-8 my-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">1. Responsibilities:</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li><span className='text-purple-800 font-bold'>Technical Guidance:</span> Provide expert advice and recommendations related to specific technical matters, such as engineering, science, information technology, or other specialized areas.</li>
                                    <li><span className='text-purple-800 font-bold'>Problem Solving:</span> Assist in identifying and solving technical challenges and issues that may arise in a project or within an organization.</li>
                                    <li><span className='text-purple-800 font-bold'>Project Support:</span> Advise on the planning, design, and execution of technical projects, ensuring they align with best practices and industry standards.</li>
                                    <li><span className='text-purple-800 font-bold'>Risk Assessment:</span> Evaluate technical risks associated with projects, technologies, or processes and recommend mitigation strategies.</li>
                                    <li><span className='text-purple-800 font-bold'>Technology Evaluation:</span> Assess new technologies, products, or solutions for suitability and compatibility with an organization's needs and objectives.</li>
                                    <li><span className='text-purple-800 font-bold'>Compliance and Regulations:</span> Ensure that technical processes and solutions meet regulatory and compliance requirements within a given industry.</li>
                                    <li><span className='text-purple-800 font-bold'>Training and Education:</span> Provide training and education to clients, employees, or team members to enhance their technical knowledge and skills.</li>
                                    <li><span className='text-purple-800 font-bold'>Research and Development:</span> Support research and development activities by offering insights and expertise in innovative technologies and practices.</li>
                                    <li><span className='text-purple-800 font-bold'>Quality Assurance:</span> Implement quality control measures and best practices to maintain high standards in technical work.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">2. Characteristics:</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li><span className='text-purple-800 font-bold'>Expertise:</span> A technical advisor possesses in-depth knowledge and expertise in their field, often with a strong academic and professional background.</li>
                                    <li><span className='text-purple-800 font-bold'>Problem-Solving Skills:</span> They are skilled at analyzing complex technical issues and providing effective solutions.</li>
                                    <li><span className='text-purple-800 font-bold'>Communication:</span> Effective communication skills are crucial to convey technical information to non-technical stakeholders in a clear and understandable manner.</li>
                                    <li><span className='text-purple-800 font-bold'>Adaptability:</span> Technical advisors stay current with industry trends and emerging technologies to adapt and provide relevant advice.</li>
                                    <li><span className='text-purple-800 font-bold'>Ethical Conduct:</span> They adhere to ethical standards and principles in their work, including confidentiality and professional integrity.</li>
                                    <li><span className='text-purple-800 font-bold'>Collaboration:</span> They work well in multidisciplinary teams and collaborate with other experts to achieve project goals</li>
                                    <li><span className='text-purple-800 font-bold'>Research-Oriented:</span> Technical advisors may be involved in ongoing research to expand their knowledge and stay at the forefront of their field.</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>


                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">

                    <p className="mb-4">
                    Technical advisors can be found in various industries, including engineering, healthcare, information technology, finance, and more. Their expertise is sought after to ensure the success and efficiency of projects and processes, as well as to address technical challenges and opportunities effectively.
                    </p>
                </div>


                {/* All Work Section */}
                <div className="my-12 text-center">
                    <h2 className="text-2xl font-bold text-purple-800 mb-4">All Work</h2>
                    <p className="text-lg text-gray-700 mb-4">We provide high standard work for your Company solutions</p>
                </div>

                {/* Images Section */}
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>


                    {/* Modal to show selected image */}
                    {selectedImage && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                            <div className="relative">
                                <img
                                    src={selectedImage}
                                    alt="Selected"
                                    className="max-w-full max-h-screen rounded-lg"
                                />
                                <button
                                    onClick={handleClose}
                                    className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                                >
                                    ✖
                                </button>
                            </div>
                        </div>
                    )}
            </div>

            {/* <Footer /> */}
        </div>
    );
};

export default Card07;
